module.exports = __webpack_public_path__ + "img/Slice 268@2x(7).dd6553d4.png";